import { Controller } from "@hotwired/stimulus";
import html from "html-template-tag";

const integerFormatter = (value: number) => {
  const formatter = new Intl.NumberFormat('en-NZ');
  return formatter.format(value);
}

export default class extends Controller {
  static targets = [
    "topSellersLoading",
    "topSellersBody",
  ];
  static values = {
    analyticsFunctionUrl: String,
    analyticsAuthorizationToken: String,
  }

  declare topSellersLoadingTarget: HTMLElement;
  declare topSellersBodyTarget: HTMLElement;
  declare analyticsFunctionUrlValue: string;
  declare analyticsAuthorizationTokenValue: string;

  connect(): void {
    if (!this.analyticsFunctionUrlValue || !this.analyticsAuthorizationTokenValue) return;
    void this.loadTopSellers();
  }

  async loadTopSellers(): Promise<void> {
    const response = await fetch(`${this.analyticsFunctionUrlValue}&name=TopSellingProductsList&limit=10`, {
      headers: {
        'Authorization': `Bearer ${this.analyticsAuthorizationTokenValue}`,
      }
    });

    if (!response.ok) {
      console.log('Analytics load failed', response);
      return;
    }

    const json = (await response.json()) as { item_name: string, total_quantity_ordered: number }[];

    this.topSellersBodyTarget.innerHTML = json.map((row) => {
      return html`<tr><td>${row.item_name}</td><td>${integerFormatter(row.total_quantity_ordered)}</td></tr>`;
    }).join('');
    this.topSellersLoadingTarget.classList.remove('is-loading');
  }
}